function resolveKpiBase () {
  const raw = process.env.VUE_APP_RUTA_API_RH || 'https://escuelakpi.club/kpi/'
  return raw.endsWith('/') ? raw : `${raw}/`
}

export async function obtenerWhatsappRecomienda ({ escuela, idAlumno, matricula }) {
  const params = new URLSearchParams()
  if (matricula) params.set('matricula', matricula)
  const qs = params.toString()
  const url = `${resolveKpiBase()}recomienda.whatsapp/${escuela}/${idAlumno}${qs ? `?${qs}` : ''}`
  const res = await fetch(url)
  if (!res.ok) {
    throw new Error('No se pudo resolver el WhatsApp de recomendados')
  }
  return res.json()
}

export function mensajeWhatsappRecomienda (matricula) {
  return `Hola, me interesa aprovechar el descuento especial para estudiar inglés. Me recomendó el alumno con matricula ${matricula}`
}
